import { WEventType } from './WEventType';
import { WMessage } from './WMessage';

export abstract class WEvent implements WMessage {
  eventType: WEventType;
  eventTime: string;
  tableId: string;

  protected constructor(
    tableId: string,
    eventType: WEventType,
    eventTime: string,
  ) {
    this.tableId = tableId;
    this.eventType = eventType;
    this.eventTime = eventTime;
  }

  abstract applyWebsocketChanges: () => Promise<void>;
}
